import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";
import {
  PostServiceCaller,
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import Select from "react-select";

const ObjectType = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Object Type Add"));
  }, []);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    DisplayName: "",
    Group_077: "",
    SubGroup_078: "",
    MenuSequence: "",
    ShowIn_102: "",
    CheckPermissions: 0,
    DefaultNarration_071: "",
    DefaultLedgerType_002: "",
    PluginName_081: "",
    ControllerName_082: "",
    ActionName_083: "",
    CopyTaxesFromParent: 0,
    CopyAccountsFromParent: 0,
    ValidityDays: "",
    IsAdd: 0,
    IsEdit: 0,
    IsDelete: 0,
    RoundOffValue: "",
    RoundOffLevel_035: "",
    RoundOffAccountID: "",
    TradeDiscountAccountID: "",
    TradeDiscountAccountIDAfterTax: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [menuList, setMenuList] = useState([]);
  const [headingList, setheadingList] = useState([]);
  const [showINList, setShowINList] = useState([]);
  const [plugINList, setPlugINList] = useState([]);
  const [controllerList, setControllerList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [defaultLedger,setDefaultLedger] = useState([]);
  const [round, setRound] = useState([]);
  const [errors, setErrors] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [isMenuSelected, setIsMenuSelected] = useState(false);

  const fetchObjTypeData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/object-type/add-page/details`
      );

      // Menu List Options
      const TnE = response?.data?.data?.menu;
      const menuOpt = TnE.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setMenuList(menuOpt);

      // heading List
      const headOpt = response?.data?.data?.heading;
      const headingOpt = headOpt.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setheadingList(headingOpt);

      // showIN Options
      const showList = response?.data?.data?.showin;
      const showoptlist = showList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setShowINList(showoptlist);

      // plugin IN List
      const pluginList = response?.data?.data?.plugIn;
      const plugoptlist = pluginList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setPlugINList(plugoptlist);

      // controller List
      const controlList = response?.data?.data?.controller;
      const controlOptlist = controlList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setControllerList(controlOptlist);

      // Action List
      const actionOptList = response?.data?.data?.action;
      const actOptlist = actionOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setActionList(actOptlist);

      // Account List
      const accountOptList = response?.data?.data?.accountID;
      const acctOptlist = accountOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setAccountList(acctOptlist);

      // ledger type optin
      const ledgerOptList = response?.data?.data?.defaultLedgerType;
      const defledgerOptlist = ledgerOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDefaultLedger(defledgerOptlist);
      // RoundOff level list
      const roundOptList = response?.data?.data?.roundOffLevel;
      const rOptlist = roundOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setRound(rOptlist);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchObjTypeData();
  }, []);

  const handleChange = async (e) => {
    const { name, checked, type, value } = e.target;
    const fieldValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: fieldValue,
    }));

    // Validate on change
    validateField(name, { [name]: fieldValue });
  };

  const handleSelect = (selectedOption, name) => {
    if (name === "Group_077") {
      setIsMenuSelected(!!selectedOption); 
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedOption.value,
    }));
  };

  const schema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await schema.validate(formData, { abortEarly: false });
      const response = await PostServiceCaller(
        `${API_URL}rujul/object-type`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (err) {
      if (err.inner) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
      }
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="Container">
        <form onSubmit={handleSubmit} id="formOne" className="rounded mt-2 bg-white">
          <div className="row">
            <div className="col-md-12">
              {/* General Details */}
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">General Details</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div>
                        <label className="form-label">Code</label>
                        <input
                          type="text"
                          name="Code"
                          placeholder="Code"
                          className="form-control"
                          value={formData?.Code}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">
                          Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className="form-control"
                          value={formData?.Name}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.Name && (
                          <div className="text-danger">{errors.Name}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          name="Description"
                          placeholder="Description"
                          className="form-control"
                          value={formData?.Description}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">
                          Object Type Identifier
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder=""
                          disabled
                          className="form-control"
                          //   value={formData?.Name}
                          //   onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Menu
                        </label>
                        <Select
                          options={menuList}
                          name="Group_077"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                      Heading
                        </label>
                        <Select
                          options={headingList}
                          name="SubGroup_078"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Additional Details */}
          <div className="row mt-2">
            <div className="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">Additional Details</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Display Name</label>
                        <input
                          type="text"
                          name="DisplayName"
                          placeholder="Display Name"
                          className="form-control"
                          value={formData?.DisplayName}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                         Default Ledger Type
                        </label>
                        <Select
                          options={defaultLedger}
                          name="DefaultLedgerType_002"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                    </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Default Narration</label>
                        <input
                          type="text"
                          name="Name"
                          placeholder=""
                          disabled
                          className="form-control"
                          //   value={formData?.Name}
                          //   onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Show In
                        </label>
                        <Select
                          options={showINList}
                          name="ShowIn_102"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Menu Sequence</label>
                        <input
                          type="text"
                          name="MenuSequence"
                          placeholder="Menu Sequence"
                          className="form-control"
                          value={formData?.MenuSequence}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Validity Days</label>
                        <input
                          type="text"
                          name="ValidityDays"
                          placeholder="ValidityDays"
                          className="form-control"
                          value={formData?.ValidityDays}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CopyTaxesFromParent"
                        id="flexSwitchCheckChecked"
                        checked={formData.CopyTaxesFromParent === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Copy Taxes</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CheckPermissions"
                        id="flexSwitchCheckChecked"
                        checked={formData.CheckPermissions === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">
                        Check Permission
                      </label>
                    </div>
                    <div className="col-md-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CopyAccountsFromParent"
                        id="flexSwitchCheckChecked"
                        checked={formData.CopyAccountsFromParent === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">
                        Copy Account From Parent
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1 g-2">
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Log Setting Details</h5>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsAdd"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsAdd === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Add</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsEdit"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsEdit === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Edit</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsDelete"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsDelete === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Delete</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h5 className="subheading">Menu Setting Details</h5>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Plugin
                        </label>
                        <Select
                          options={plugINList}
                          name="PluginName_081"
                          isDisabled={!isMenuSelected}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Controller
                        </label>
                        <Select
                          options={controllerList}
                          name="ControllerName_082"
                          isDisabled={!isMenuSelected}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Action
                        </label>
                        <Select
                          options={actionList}
                          name="ActionName_083"
                          isDisabled={!isMenuSelected}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1 g-2">
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Round Off Details</h5>
                </div>
                <div className="card-body p-2">
                  <div class="row">
                    <div class="col-md-4">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                          Round Off Level
                        </label>
                        <Select
                          options={round}
                          name="RoundOffLevel_035"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label className="form-label">Round Off</label>
                        <input
                          type="text"
                          name="RoundOffValue"
                          placeholder="Round Off"
                          className="form-control"
                          value={formData?.RoundOffValue}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                        Account
                        </label>
                        <Select
                          options={accountList}
                          name="RoundOffAccountID"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Default Account Setting</h5>
                </div>
                <div className="card-body p-2">
                  <div class="row">
                    <div class="col-md-6">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                        Trade Disc. Account
                        </label>
                        <Select
                          options={accountList}
                          name="TradeDiscountAccountID"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                    <div class="mb-3">
                        <label for="Code" class="form-label">
                        Trade Disc. Account After Tax
                        </label>
                        <Select
                          options={accountList}
                          name="TradeDiscountAccountIDAfterTax"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <div className="d-flex me-2">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => (window.location.href = "/rujul/admin/object-type")}
                >
                  Cancel
                </button>
              </div>
              <div>
                <button type="submit" className="custom-btn">
                  {/* {loading ? <FaSpinner class="sm-spinner" /> : "Submit"} */}
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

export default ObjectType;
